import GasPumpCircle from './GasPumpCircle';

export default GasPumpCircle;
